import { render, staticRenderFns } from "./GPagination.vue?vue&type=template&id=6349b35a&scoped=true&"
import script from "./GPagination.vue?vue&type=script&lang=js&"
export * from "./GPagination.vue?vue&type=script&lang=js&"
import style0 from "./GPagination.vue?vue&type=style&index=0&id=6349b35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6349b35a",
  null
  
)

export default component.exports